export default "__VITE_ASSET__DWpto0YM__"